export const dishes = [
  {
    id: "1",
    slug: "chicken-ala-kiev",
    name: "Chicken Ala Kiev",
    category: "Chef's Signature",
    tagline: "A French classic, perfected over generations",
    image:
      "https://readdy.ai/api/search-image?query=Chicken%20ala%20kiev%20on%20elegant%20white%20plate%20with%20herb%20butter%20garnish%2C%20rosemary%20sprigs%2C%20warm%20amber%20lighting%2C%20editorial%20food%20photography%20style%2C%20rustic%20linen%20napkin%2C%20dark%20wooden%20table%20background%2C%20luxurious%20presentation&width=600&height=700&seq=dish-ala-kiev&orientation=portrait",
    story:
      "Do you remember your first cut, the occasion, or the person across the table?",
    origin: "",
    ingredients: [
      "Free-range chicken breast",
      "European-style herb butter",
      "Fresh dill & parsley",
      "Golden breadcrumb crust",
      "Lemon zest infusion",
    ],
    chefNotes:
      "The secret is in the butter. We infuse European-style butter with fresh herbs and let it rest for 48 hours before it meets the chicken. The result is an explosion of flavor that transforms a simple cutlet into an experience.",
    pairings: ["Sauvignon Blanc", "Garden Salad", "Garlic Mashed Potatoes"],
    relatedStorySlug: "chicken-ala-kiev-untold-story",
    price: "",
  },
  {
    id: "2",
    slug: "english-breakfast",
    name: "English Breakfast",
    category: "Chef's Signature",
    tagline: "The best of Europe, served on one plate",
    image:
      "https://readdy.ai/api/search-image?query=Continental%20brunch%20platter%20with%20eggs%20benedict%2C%20smoked%20salmon%2C%20avocado%20toast%2C%20fresh%20berries%2C%20elegant%20white%20ceramic%20plate%2C%20warm%20morning%20light%2C%20editorial%20food%20photography%20style%2C%20fresh%20greens%20garnish&width=600&height=700&seq=dish-brunch&orientation=portrait",
    story:
      "A weekend ritual, a travel discovery, or a shared morning that became a favourite memory?",
    origin: "",
    ingredients: [
      "Farm-fresh eggs",
      "Smoked salmon",
      "Artisan sourdough",
      "Avocado & microgreens",
      "House-made hollandaise",
    ],
    chefNotes:
      "We source our eggs from a farm in Sonarpur where the chickens roam free. Our hollandaise is made fresh every morning — no shortcuts, no powders. The sourdough bread is baked in-house using a starter that is now three years old.",
    pairings: ["Mimosa", "Fresh Orange Juice", "Earl Grey Tea"],
    relatedStorySlug: "chef-diaries-sundays-at-courtyard",
    price: "",
  },
  {
    id: "3",
    slug: "bacon-wrapped-prawns",
    name: "Bacon Wrapped Prawns",
    category: "Community Favourites",
    tagline: "Tuscany on a plate, made fresh every morning",
    image:
      "https://readdy.ai/api/search-image?query=Handmade%20pappardelle%20pasta%20with%20rich%20slow-braised%20lamb%20ragu%2C%20wide%20pasta%20ribbons%2C%20parmesan%20shavings%2C%20fresh%20basil%20garnish%2C%20warm%20rustic%20bowl%2C%20editorial%20food%20photography%20style%2C%20cozy%20Italian%20atmosphere&width=600&height=700&seq=dish-pappardelle&orientation=portrait",
    story:
      "Which unexpected pairing first surprised you, and whose table introduced you to it?",
    origin: "",
    ingredients: [
      "Hand-rolled egg pasta",
      "Slow-braised lamb ragu",
      "San Marzano tomatoes",
      "Aged Parmigiano-Reggiano",
      "Fresh basil & olive oil",
    ],
    chefNotes:
      "The pasta dough rests for exactly 30 minutes after kneading — any less and it is tense, any more and it is tired. The lamb ragu cooks low and slow for six hours until the meat melts into the sauce. This is not fast food. This is patient food.",
    pairings: ["Chianti Classico", "Bruschetta", "Tiramisu"],
    relatedStorySlug: "tuscany-to-kolkata",
    price: "",
  },
  {
    id: "4",
    slug: "the-courtyard-steak",
    name: "The Courtyard Steak",
    category: "Community Favourites",
    tagline: "The coast of Normandy, reimagined in Kolkata",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20grilled%20seafood%20platter%20with%20prawns%2C%20sea%20bass%2C%20scallops%2C%20lemon%20wedges%2C%20herb%20butter%20drizzle%2C%20white%20linen%20table%20setting%2C%20editorial%20food%20photography%20style%2C%20coastal%20elegant%20atmosphere%2C%20warm%20natural%20lighting&width=600&height=700&seq=dish-seafood&orientation=portrait",
    story:
      "What makes a meal memorable for you - the flavours, the setting, or the company?",
    origin: "",
    ingredients: [
      "Fresh sea bass",
      "Tiger prawns",
      "Scallops",
      "Normandy-style herb butter",
      "Lemon & caper reduction",
    ],
    chefNotes:
      "Our fish arrives every morning at 6 AM from the New Market. I personally inspect each piece — the eyes should be clear, the flesh firm, the smell of the ocean. Anything less, and it does not make it to the grill.",
    pairings: ["White Burgundy", "Crusty Baguette", "Seasonal Greens"],
    relatedStorySlug: "continental-coffee-culture",
    price: "",
  },
  {
    id: "5",
    slug: "seasonal-risotto",
    name: "Seasonal Risotto",
    category: "Seasonal Specials",
    tagline: "What the season brings, we celebrate",
    image:
      "https://readdy.ai/api/search-image?query=Creamy%20mushroom%20risotto%20in%20shallow%20white%20bowl%20with%20truffle%20shavings%2C%20parmesan%20crisp%2C%20microgreens%20garnish%2C%20warm%20candlelit%20ambiance%2C%20editorial%20food%20photography%20style%2C%20Italian%20fine%20dining%20atmosphere%2C%20rich%20earthy%20tones&width=600&height=700&seq=dish-risotto&orientation=portrait",
    story:
      "Risotto is a canvas, and the seasons are our palette. In monsoon, wild mushrooms. In winter, butternut squash and sage. In summer, fresh peas and mint. Each version tells the story of a particular moment in time.",
    origin: "Northern Italy",
    ingredients: [
      "Arborio rice",
      "Seasonal produce",
      "House-made vegetable stock",
      "Butter & Parmigiano",
      "White wine reduction",
    ],
    chefNotes:
      "True risotto cannot be rushed. The stirring is meditation, not labor. Each ladle of stock must be fully absorbed before the next is added. The result is a texture that is neither soup nor solid — it is alla onda, like a wave.",
    pairings: ["Pinot Grigio", "Antipasto Platter", "Affogato"],
    relatedStorySlug: "chef-diaries-sundays-at-courtyard",
    price: "",
  },
  {
    id: "6",
    slug: "viennese-melange",
    name: "Viennese Melange",
    category: "Coffee Collection",
    tagline: "The coffee that built an empire of ideas",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20Viennese%20coffee%20melange%20in%20classic%20glass%20cup%20with%20whipped%20cream%20top%2C%20served%20on%20vintage%20silver%20tray%2C%20small%20chocolate%20beside%20it%2C%20warm%20cafe%20interior%20background%2C%20editorial%20food%20photography%20style%2C%20European%20elegance&width=600&height=700&seq=dish-melange&orientation=portrait",
    story:
      "In Vienna, the Melange is not just coffee — it is a way of life. Served with a glass of water and a newspaper, it marks the beginning of a slow, thoughtful morning. At Cafe Courtyard, we bring that Viennese ritual to Kolkata.",
    origin: "Vienna, Austria",
    ingredients: [
      "Single-origin Arabica beans",
      "Steamed milk",
      "Light foam crown",
      "Dark chocolate shavings",
    ],
    chefNotes:
      "We use beans from a small roaster who understands the continental roast profile — darker than third-wave, lighter than commercial. The milk is steamed to exactly 65 degrees Celsius. The foam should be silky, not stiff.",
    pairings: ["Apple Strudel", "Linzer Torte", "Morning Newspaper"],
    relatedStorySlug: "continental-coffee-culture",
    price: "",
  },
  {
    id: "7",
    slug: "classic-tiramisu",
    name: "Classic Tiramisu",
    category: "Sweet Endings",
    tagline: "Pick me up, in the most delicious way",
    image:
      "https://readdy.ai/api/search-image?query=Classic%20Italian%20tiramisu%20in%20elegant%20glass%20dish%20with%20distinctive%20layers%20visible%2C%20cocoa%20powder%20dust%2C%20coffee%20beans%20scattered%2C%20warm%20candlelight%2C%20editorial%20food%20photography%20style%2C%20intimate%20dessert%20presentation%2C%20rich%20creamy%20texture&width=600&height=700&seq=dish-tiramisu&orientation=portrait",
    story:
      "Tiramisu means 'pick me up' in Italian, and that is exactly what it does. Born in the Veneto region, this dessert has traveled the world, but its essence remains unchanged — coffee, mascarpone, and a little bit of magic.",
    origin: "Veneto, Italy",
    ingredients: [
      "Espresso-soaked ladyfingers",
      "Hand-whipped mascarpone",
      "Farm-fresh eggs",
      "Cocoa powder dusting",
      "A touch of marsala",
    ],
    chefNotes:
      "Our mascarpone is whipped by hand — never over-beaten, never under-beaten. The espresso is brewed specifically for the Tiramisu, slightly stronger than our drinking espresso. Each layer is assembled with patience. Good Tiramisu cannot be rushed.",
    pairings: ["Espresso", "Amaretto", "Dark Chocolate"],
    relatedStorySlug: "secret-of-continental-desserts",
    price: "",
  },
  {
    id: "8",
    slug: "chocolate-fondant",
    name: "Chocolate Fondant",
    category: "Sweet Endings",
    tagline: "A molten river of dark chocolate perfection",
    image:
      "https://readdy.ai/api/search-image?query=Chocolate%20fondant%20lava%20cake%20with%20molten%20center%20flowing%20out%2C%20vanilla%20ice%20cream%20scoop%20beside%2C%20raspberry%20garnish%2C%20warm%20dramatic%20lighting%2C%20editorial%20food%20photography%20style%2C%20luxury%20dessert%20presentation%2C%20dark%20rich%20chocolate%20tones&width=600&height=700&seq=dish-fondant&orientation=portrait",
    story:
      "The Chocolate Fondant is a test of precision. Sixty seconds too long in the oven, and it is just a chocolate cake. Sixty seconds too short, and it collapses. In that perfect window, it becomes something transcendent.",
    origin: "France",
    ingredients: [
      "70% dark Belgian chocolate",
      "French butter",
      "Free-range eggs",
      "Vanilla bean",
      "A pinch of sea salt",
    ],
    chefNotes:
      "Timing is everything. The oven must be exactly 200 degrees. The ramekins must be buttered and dusted with cocoa powder. When the fondant comes out, the exterior should be firm, the interior liquid gold. The first spoonful should make you pause.",
    pairings: ["Vanilla Bean Ice Cream", "Espresso", "Port Wine"],
    relatedStorySlug: "secret-of-continental-desserts",
    price: "",
  },
];